export const { phone1, phone2, whatsapp, email, email2, website, address } = {
  phone1: "+91 88840 57812",
  phone2: "+91 86186 28045",
  whatsapp: "918618628045",
  email: "sales@akfire.in",
  email2: "accounts@akfire.in",
  website: "www.akfire.in",
  address:
    "Unit No. 114, 1st Floor, Dipti Square, Subhash Road, Jogeshwari (East), Near R.C. Industrial Estate, Mumbai – 400060",
};
